export default __webpack_public_path__ + "static/media/q12_v2.2574e5fa.png";